import { HsForce } from './force.class';

export class HsGravityForce extends HsForce {
  constructor(strength: number = 1) {
    super(strength);
    this.direction.set(0, -1, 0);
  }
}
